import DailyMenuOptionOffer from '@/model/DailyMenuOptionOffer'

export default class DailyMenuOption {
  private constructor (
    readonly id: string,
    readonly name: string,
    readonly code: string,
    readonly isSelected: boolean,
    readonly offer: DailyMenuOptionOffer | undefined

  ) {}


  static createFromResponse (responseData: any[]): DailyMenuOption[] {

    return responseData.map( (value:any):DailyMenuOption =>new DailyMenuOption(
        value.id,
        value.name,
        value.code,
        value.selected,
        DailyMenuOptionOffer.createFromResponse(value.offer)

    ))

  }
}
